export function LoadingSkeleton() {
  return (
    <div className="animate-pulse space-y-8">
      {/* Header Skeleton */}
      <div className="h-12 w-2/3 rounded-lg bg-gradient-to-r from-gray-800 to-gray-700"></div>
      <div className="h-6 w-1/3 rounded-lg bg-gradient-to-r from-gray-800 to-gray-700"></div>

      {/* Event Cards Skeleton */}
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            className="overflow-hidden rounded-xl border border-[#D4AF37]/10 bg-gradient-to-br from-black/60 to-black/40 backdrop-blur-md"
          >
            {/* Image Skeleton */}
            <div className="h-64 bg-gradient-to-r from-gray-800 to-gray-700"></div>

            {/* Content Skeleton */}
            <div className="space-y-4 p-6">
              <div className="h-6 w-3/4 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
              <div className="h-4 w-1/2 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
              <div className="h-4 w-2/3 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
              <div className="flex justify-between pt-4">
                <div className="h-8 w-24 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
                <div className="h-8 w-32 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function EventDetailSkeleton() {
  return (
    <div className="animate-pulse space-y-8">
      {/* Hero Image Skeleton */}
      <div className="h-96 rounded-xl bg-gradient-to-r from-gray-800 to-gray-700"></div>

      {/* Title and Details Skeleton */}
      <div className="space-y-4">
        <div className="h-12 w-3/4 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
        <div className="flex gap-4">
          <div className="h-6 w-32 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
          <div className="h-6 w-32 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
        </div>
      </div>

      {/* Description Skeleton */}
      <div className="space-y-3">
        <div className="h-4 w-full rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
        <div className="h-4 w-full rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
        <div className="h-4 w-2/3 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
      </div>

      {/* Package Cards Skeleton */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="space-y-4 rounded-xl border border-[#D4AF37]/10 bg-black/40 p-6 backdrop-blur-md"
          >
            <div className="h-8 w-32 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
            <div className="h-10 w-24 rounded bg-gradient-to-r from-gray-800 to-gray-700"></div>
            <div className="space-y-2">
              {[1, 2, 3, 4].map((j) => (
                <div
                  key={j}
                  className="h-4 w-full rounded bg-gradient-to-r from-gray-800 to-gray-700"
                ></div>
              ))}
            </div>
            <div className="h-12 w-full rounded-lg bg-gradient-to-r from-gray-800 to-gray-700"></div>
          </div>
        ))}
      </div>
    </div>
  );
}
